import Clipboard from '../snippets/clipboard'

Clipboard.init()
